import Swiper from "swiper";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/mousewheel";
import "swiper/css/pagination";

//パラメータは以下参照
//https://swiperjs.com/swiper-api#parameters

export function sliderVertical(sliderVEl) {
  if ($(sliderVEl).length) {
    const swiperVertical = new Swiper(sliderVEl, {
      direction: 'vertical',
      spaceBetween: 4,
      slidesPerView: 1,
      centeredSlides: true,
      effect: 'slide',
      modules: [Mousewheel, Pagination],
      mousewheel: {
        invert: false,
        releaseOnEdges: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // クリック可能にする
      },
    });
  }
}
